import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from 'src/app/services/auth/storage.service';
import { environment } from 'src/environments/environment';

interface ResponseB4A<T> {
  result: T;
}

export interface BillingContract {
  subscriberBillingId?: number;
  subscriberId?: number;
  editionId?: number;
  contractSubscriberId?: number;
  statusContract?: number;
  pedidoV?: string;
  dateCreated?: string | Date;
  dateUpdated?: string | Date;
  endEditionId?: number;
  nPedidoCliente?: string;
}

export interface CancelBillingContractResult {
  subscriberBillingId?: number;
  contractSubscriberId?: number;
  message?: string;
}

/**
 * Temporary client until OpenAPI regen includes SubscriberBillingContractController.
 * Endpoints: GET/POST /subscriber/admin/billing/{id}/contracts...
 */
@Injectable({ providedIn: 'root' })
export class SubscriberBillingContractService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/subscriber/admin/billing`;

  listContracts(subscriberBillingId: number): Observable<BillingContract[]> {
    return this.http
      .get<ResponseB4A<BillingContract[]>>(
        `${this.baseUrl}/${encodeURIComponent(String(subscriberBillingId))}/contracts`,
        { headers: this.authHeaders() }
      )
      .pipe(map((response) => response.result ?? []));
  }

  cancelContract(
    subscriberBillingId: number,
    contractSubscriberId: number
  ): Observable<CancelBillingContractResult> {
    return this.http
      .post<ResponseB4A<CancelBillingContractResult>>(
        `${this.baseUrl}/${encodeURIComponent(String(subscriberBillingId))}/contracts/${encodeURIComponent(String(contractSubscriberId))}/cancel`,
        {},
        { headers: this.authHeaders() }
      )
      .pipe(map((response) => response.result ?? {}));
  }

  private authHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    if (StorageService.userLogged && StorageService.token) {
      return headers.set('Authorization', `Bearer ${StorageService.token}`);
    }
    return headers;
  }
}
